export type SettingsViewId =
  | "unit-price-list-lines"
  | "unit-prices-for-contracts"
  | "general-sidecost-groups"
  | "contract-sidecost-groups"
  | "contract-crews"
  | "contract-machines"
  | "subscribers"
  | "deputies"
  | "user-defaults";

export interface SettingsLinkItem {
  id: SettingsViewId;
  translationKey: string;
  defaultLabel: string;
  /** Same function codes as PHP checkRightsFromDB; omit to show for any user who can open Settings. */
  requiredPermission?: string;
}

export const settingsLinks: SettingsLinkItem[] = [
  {
    id: "unit-price-list-lines",
    translationKey: "TEXT_LINK_YLEISET_TYOVAIHEET",
    defaultLabel: "Unit price list lines",
    requiredPermission: "ADMIN_PRICES",
  },
  {
    id: "unit-prices-for-contracts",
    translationKey: "TEXT_LINK_SOPIMUKSEN_TYOVAIHEET",
    defaultLabel: "Unit prices for contracts",
    requiredPermission: "ADMIN_PRICES",
  },
  {
    id: "general-sidecost-groups",
    translationKey: "TEXT_LINK_YLEISET_SIVUKULUT",
    defaultLabel: "General indirect cost groups",
    requiredPermission: "SIVUKULUT_YLLAPITO",
  },
  {
    id: "contract-sidecost-groups",
    translationKey: "TEXT_LINK_SOPIMUKSEN_SIVUKULUT",
    defaultLabel: "Contract indirect costs",
    requiredPermission: "SIVUKULUT_YLLAPITO",
  },
  {
    id: "contract-crews",
    translationKey: "TEXT_LINK_CREWS",
    defaultLabel: "Working groups (crews)",
    requiredPermission: "ADMIN_PRICES",
  },
  {
    id: "contract-machines",
    translationKey: "TEXT_LINK_MACHINES",
    defaultLabel: "Equipment (machines)",
    requiredPermission: "ADMIN_PRICES",
  },
  {
    id: "subscribers",
    translationKey: "TEXT_LINK_SUBSCRIBERS",
    defaultLabel: "Subscribers",
    requiredPermission: "ADMIN_PRICES",
  },
  {
    id: "deputies",
    translationKey: "TEXT_LINK_DEPUTY",
    defaultLabel: "Deputies",
    requiredPermission: "CITY_OBJECT_DEPUTY_MANAGEMENT",
  },
  {
    id: "user-defaults",
    translationKey: "TEXT_LINK_USER_DEFAULTS",
    defaultLabel: "User Default Settings",
    requiredPermission: "CITY_OBJECT_SHOW",
  },
];


export const permissionNoteConfig = {
  translationKey: "SETTINGS_BASED_ON_PERMISSIONS",
  defaultLabel: "based on user permissions",
};
